import IObservable from "./IObservable";

/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */

export default class Observable<T> implements IObservable<T>
{
    public static readonly ChangedEventName: string = "Observable.ValueChanged";

    protected value?: T = null;
    public get Value(): T { return this.GetValue(); }
    public set Value(value: T) { this.SetValue(value); }

    protected oldValue?: T = null;
    public get OldValue(): T { return this.oldValue; }

    public HasValue(): boolean { return this.value !== null && this.value !== undefined; }

    private _eventDispatcher: cc.EventTarget = new cc.EventTarget();

    constructor(value?: T)
    {
        this.value = value;
    }

    public SetValue(value: T): Observable<T>
    {
        if (this.value === value) { return this; }

        this.oldValue = this.value;
        this.value = value;

        this._eventDispatcher.emit(Observable.ChangedEventName, value);

        return this;
    }

    public GetValue(): T
    {
        return this.value;
    }

    public OnChanged(fnOnChange: (event?: cc.Event.EventCustom) => void): void
    {
        this._eventDispatcher.on(Observable.ChangedEventName, fnOnChange);
    }

    public OffChanged(fnOnChange: (event?: cc.Event.EventCustom) => void): void
    {
        this._eventDispatcher.off(Observable.ChangedEventName, fnOnChange);
    }
}
